/*

==========================================================

DH Commerce Framework

Version: 1.4.0

Author: OpenAI + DH Foods

 

This file is the global commerce framework.

 

It intentionally DOES NOT replace the existing homepage

JavaScript yet.

 

Instead it provides:

 

• Shared Commerce State

• Event Bus

• Analytics

• Shipping Intelligence

• Promotion Engine (placeholder)

• Dashboard Hooks

 

Existing homepage code will gradually migrate into this

framework over the next development sprints.

 

==========================================================

*/

 

(function (window, document) {

 

  "use strict";

 

  /*

Allow this version to replace an older DH Commerce framework.

Prevent only the same version from initializing twice.

*/

 

if (

  window.DHCommerce &&

  window.DHCommerce.version === "1.4.0"

) {

  return;

}

 

const DHCommerce = {};

 

DHCommerce.sequence = 0;

 

  DHCommerce.build = "2026-07-17";

  DHCommerce.name = "DH Commerce Framework";

  DHCommerce.apiVersion = "1";

 

  /* ======================================================

     VERSION

  ====================================================== */

 

  DHCommerce.version = "1.4.0";

 

  /* ======================================================

     CONFIGURATION

  ====================================================== */

 

  DHCommerce.config = {

 

    shipping: {

 

      unknownBehavior: "far",

 

      near: {

        freeShippingThreshold: 59,

        giftThreshold: 69

      },

 

      middle: {

        freeShippingThreshold: 79,

        giftThreshold: 89

      },

 

      far: {

        freeShippingThreshold: 99,

        giftThreshold: 109

      }

 

    },

 

    promotions: {

 

      activePromotionId: "weekend_shipping_test",

 

      library: {

 

        weekend_shipping_test: {

 

          id: "weekend_shipping_test",

 

          active: true,

 

          priority: 100,

 

          type: "shipping_and_gift",

 

          name: "Weekend Shipping Test",

 

          startsAt: null,

 

          endsAt: null,

 

          tiers: {

 

            near: {

 

              enabled: true,

 

              eyebrow: "Local Advantage",

 

              headline: "Fresh Desserts. Better Shipping.",

 

              message:

                "You are close to our Tennessee kitchen, so your order qualifies for our best shipping value.",

 

              offerLabel: "Free shipping at $59",

 

              freeShippingThreshold: 59,

 

              giftThreshold: 69,

 

              giftName: "Special Weekend Gift",

 

              ctaLabel: "Shop Desserts"

 

            },

 

            middle: {

 

              enabled: true,

 

              eyebrow: "Regional Delivery",

 

              headline: "Fast Regional Shipping.",

 

              message:

                "Build an assortment that gives you more dessert value from every shipment.",

 

              offerLabel: "Free shipping at $79",

 

              freeShippingThreshold: 79,

 

              giftThreshold: 89,

 

              giftName: "Special Weekend Gift",

 

              ctaLabel: "Build Your Assortment"

 

            },

 

            far: {

 

              enabled: true,

 

              eyebrow: "Nationwide Shipping",

 

              headline: "More Dessert. Better Shipping Value.",

 

              message:

                "Larger assortments make nationwide cold shipping work harder for you.",

 

              offerLabel: "Free shipping at $99",

 

              freeShippingThreshold: 99,

 

              giftThreshold: 109,

 

              giftName: "Special Weekend Gift",

 

              ctaLabel: "Build A Larger Assortment"

 

            }

 

          }

 

        }

 

      }

 

    },

 

    analytics: {

 

      enabled: true,

 

      debug: true

 

    }

 

  };

 

 

 /* ======================================================

   GLOBAL STATE

====================================================== */

 

DHCommerce.getSessionId = function () {

  const storageKey = "dhcommerce_session_id";

 

  try {

    const existingId =

      window.sessionStorage.getItem(storageKey);

 

    if (existingId) {

      return existingId;

    }

 

    const newId =

      window.crypto &&

      typeof window.crypto.randomUUID === "function"

        ? window.crypto.randomUUID()

        : "dh-session-" +

          Date.now() +

          "-" +

          Math.random()

            .toString(36)

            .slice(2);

 

    window.sessionStorage.setItem(

      storageKey,

      newId

    );

 

    return newId;

  } catch (error) {

    return (

      "dh-session-" +

      Date.now() +

      "-" +

      Math.random()

        .toString(36)

        .slice(2)

    );

  }

};

 

 

DHCommerce.getVisitorId = function () {

  const storageKey = "dhcommerce_visitor_id";

 

  try {

    const existingId =

      window.localStorage.getItem(storageKey);

 

    if (existingId) {

      return existingId;

    }

 

    const newId =

      window.crypto &&

      typeof window.crypto.randomUUID === "function"

        ? window.crypto.randomUUID()

        : "dh-visitor-" +

          Date.now() +

          "-" +

          Math.random()

            .toString(36)

            .slice(2);

 

    window.localStorage.setItem(

      storageKey,

      newId

    );

 

    return newId;

  } catch (error) {

    return (

      "dh-visitor-" +

      Date.now() +

      "-" +

      Math.random()

        .toString(36)

        .slice(2)

    );

  }

};

 

 

DHCommerce.state = {

 

    initialized: false,

 

    session: {

 

  id: DHCommerce.getSessionId(),

 

  visitorId: DHCommerce.getVisitorId()

 

},

 

    customer: {

 

      returning: false,

 

      emailKnown: false

 

    },

 

    shipping: {

 

  /*

  The actual detected value:

 

  near

  middle

  far

  unknown

  */

 

  tier: "unknown",

 

  /*

  Unknown visitors are treated like Far for commerce

  recommendations until a destination is known.

  */

 

  effectiveTier: "far",

 

  source: "default",

 

  confidence: "unknown",

 

  location: {

    country: "",

    state: "",

    city: "",

    zip: ""

  },

 

  initialized: false

 

},

 

    journey: {

 

      preference: null,

 

      category: null,

 

      product: null,

 

      pack: null

 

    },

 

    assortment: {

 

      selections: [],

 

      subtotal: 0,

 

      count: 0

 

    },

 

    promotions: {

 

      active: [],

 

      giftUnlocked: false,

 

      freeShippingUnlocked: false

 

    },

 

    analytics: {

 

      events: []

 

    }

 

  };

 

/* ======================================================

   ANALYTICS FOUNDATION

====================================================== */

 

DHCommerce.analyticsEndpoint =

  "https://ovcqgurzercvxvjlijnz.supabase.co/functions/v1/collect-commerce-event";

 

DHCommerce.dashboardEndpoint =

  "https://ovcqgurzercvxvjlijnz.supabase.co/functions/v1/get-commerce-dashboard";

 

DHCommerce.config.analytics.dashboardEndpoint =

  DHCommerce.dashboardEndpoint;

 

DHCommerce.analytics = {};

 

DHCommerce.analytics.sessionKeys = {

  startedAt: "dhcommerce_session_started_at",

  landingPage: "dhcommerce_landing_page",

  landingUrl: "dhcommerce_landing_url",

  initialReferrer: "dhcommerce_initial_referrer",

  attribution: "dhcommerce_attribution_v1",

  sequence: "dhcommerce_sequence"

};

 

DHCommerce.analytics.internalTrafficKey =

  "dhcommerce_internal_traffic";

 

DHCommerce.analytics.getSessionValue = function (key) {

  try {

    return window.sessionStorage.getItem(key);

  } catch (error) {

    return null;

  }

};

 

DHCommerce.analytics.setSessionValue = function (key, value) {

  try {

    window.sessionStorage.setItem(key, String(value));

    return true;

  } catch (error) {

    return false;

  }

};

 

DHCommerce.analytics.getSessionStartedAt = function () {

  const storedValue =

    DHCommerce.analytics.getSessionValue(

      DHCommerce.analytics.sessionKeys.startedAt

    );

 

  const parsedValue = Number(storedValue);

 

  if (parsedValue > 0) {

    return parsedValue;

  }

 

  const startedAt = Date.now();

 

  DHCommerce.analytics.setSessionValue(

    DHCommerce.analytics.sessionKeys.startedAt,

    startedAt

  );

 

  return startedAt;

};

 

DHCommerce.analytics.getLandingPage = function () {

  const key = DHCommerce.analytics.sessionKeys.landingPage;

  const storedValue = DHCommerce.analytics.getSessionValue(key);

 

  if (storedValue) {

    return storedValue;

  }

 

  const landingPage =

    window.location.pathname + window.location.search;

 

  DHCommerce.analytics.setSessionValue(key, landingPage);

 

  return landingPage;

};

 

DHCommerce.analytics.getLandingUrl = function () {

  const key = DHCommerce.analytics.sessionKeys.landingUrl;

  const storedValue = DHCommerce.analytics.getSessionValue(key);

 

  if (storedValue) {

    return storedValue;

  }

 

  const landingUrl = window.location.href;

 

  DHCommerce.analytics.setSessionValue(key, landingUrl);

 

  return landingUrl;

};

 

DHCommerce.analytics.getInitialReferrer = function () {

  const key =

    DHCommerce.analytics.sessionKeys.initialReferrer;

 

  const storedValue =

    DHCommerce.analytics.getSessionValue(key);

 

  if (storedValue !== null) {

    return storedValue || null;

  }

 

  const referrer = document.referrer || "";

 

  DHCommerce.analytics.setSessionValue(key, referrer);

 

  return referrer || null;

};

 

DHCommerce.analytics.normalizeHostname = function (value) {

  try {

    return new URL(value).hostname

      .replace(/^www\./, "")

      .toLowerCase();

  } catch (error) {

    return "";

  }

};

 

DHCommerce.analytics.isInternalReferrer = function (referrer) {

  if (!referrer) {

    return false;

  }

 

  const referrerHost =

    DHCommerce.analytics.normalizeHostname(referrer);

 

  const currentHost =

    String(window.location.hostname || "")

      .replace(/^www\./, "")

      .toLowerCase();

 

  return Boolean(

    referrerHost &&

    currentHost &&

    referrerHost === currentHost

  );

};

 

DHCommerce.analytics.getCampaignParameters = function () {

  let parameters;

 

  try {

    parameters =

      new URLSearchParams(window.location.search);

  } catch (error) {

    parameters = {

      get: function () {

        return null;

      }

    };

  }

 

  const clickId =

    parameters.get("gclid") ||

    parameters.get("fbclid") ||

    parameters.get("ttclid") ||

    parameters.get("msclkid") ||

    null;

 

  return {

    utm_source: parameters.get("utm_source"),

    utm_medium: parameters.get("utm_medium"),

    utm_campaign: parameters.get("utm_campaign"),

    utm_content: parameters.get("utm_content"),

    utm_term: parameters.get("utm_term"),

    click_id: clickId

  };

};

 

DHCommerce.analytics.classifyTrafficSource = function (

  campaign,

  referrer

) {

  campaign = campaign || {};

 

  const source =

    String(campaign.utm_source || "")

      .trim()

      .toLowerCase();

 

  const medium =

    String(campaign.utm_medium || "")

      .trim()

      .toLowerCase();

 

  const referrerHost =

    DHCommerce.analytics.normalizeHostname(

      referrer || ""

    );

 

  if (

    medium.indexOf("email") !== -1 ||

    source.indexOf("email") !== -1 ||

    source.indexOf("klaviyo") !== -1

  ) {

    return "Email";

  }

 

  if (source.indexOf("tiktok") !== -1) {

    return "TikTok";

  }

 

  if (

    source.indexOf("facebook") !== -1 ||

    source === "fb"

  ) {

    return "Facebook";

  }

 

  if (

    source.indexOf("instagram") !== -1 ||

    source === "ig"

  ) {

    return "Instagram";

  }

 

  if (source.indexOf("google") !== -1) {

    return "Google";

  }

 

  if (source.indexOf("youtube") !== -1) {

    return "YouTube";

  }

 

  if (source.indexOf("bing") !== -1) {

    return "Bing";

  }

 

  if (

    DHCommerce.analytics.isInternalReferrer(referrer)

  ) {

    return "Internal";

  }

 

  if (!source && !referrerHost) {

    return "Direct";

  }

 

  if (referrerHost.indexOf("tiktok.") !== -1) {

    return "TikTok";

  }

 

  if (

    referrerHost.indexOf("facebook.") !== -1 ||

    referrerHost.indexOf("fb.") !== -1

  ) {

    return "Facebook";

  }

 

  if (referrerHost.indexOf("instagram.") !== -1) {

    return "Instagram";

  }

 

  if (referrerHost.indexOf("google.") !== -1) {

    return "Google";

  }

 

  if (referrerHost.indexOf("youtube.") !== -1) {

    return "YouTube";

  }

 

  if (referrerHost.indexOf("bing.") !== -1) {

    return "Bing";

  }

 

  return source

    ? source

        .split(/[\s_-]+/)

        .map(function (part) {

          return part

            ? part.charAt(0).toUpperCase() +

                part.slice(1)

            : "";

        })

        .join(" ")

    : "Referral";

};

 

DHCommerce.analytics.getAttribution = function () {

  const key =

    DHCommerce.analytics.sessionKeys.attribution;

 

  const storedValue =

    DHCommerce.analytics.getSessionValue(key);

 

  if (storedValue) {

    try {

      return JSON.parse(storedValue);

    } catch (error) {

      /* Rebuild invalid stored attribution below. */

    }

  }

 

  const campaign =

    DHCommerce.analytics.getCampaignParameters();

 

  const initialReferrer =

    DHCommerce.analytics.getInitialReferrer();

 

  const attribution = {

    source:

      DHCommerce.analytics.classifyTrafficSource(

        campaign,

        initialReferrer

      ),

 

    utm_source: campaign.utm_source || null,

    utm_medium: campaign.utm_medium || null,

    utm_campaign: campaign.utm_campaign || null,

    utm_content: campaign.utm_content || null,

    utm_term: campaign.utm_term || null,

    click_id: campaign.click_id || null,

 

    referrer_host:

      DHCommerce.analytics.normalizeHostname(

        initialReferrer || ""

      ) || null

  };

 

  DHCommerce.analytics.setSessionValue(

    key,

    JSON.stringify(attribution)

  );

 

  return attribution;

};

 

DHCommerce.analytics.isInternalTraffic = function () {

  try {

    return (

      window.localStorage.getItem(

        DHCommerce.analytics.internalTrafficKey

      ) === "true"

    );

  } catch (error) {

    return false;

  }

};

 

DHCommerce.analytics.markInternal = function () {

  try {

    window.localStorage.setItem(

      DHCommerce.analytics.internalTrafficKey,

      "true"

    );

 

    return true;

  } catch (error) {

    return false;

  }

};

 

DHCommerce.analytics.clearInternal = function () {

  try {

    window.localStorage.removeItem(

      DHCommerce.analytics.internalTrafficKey

    );

 

    return true;

  } catch (error) {

    return false;

  }

};

 

DHCommerce.analytics.getDeviceType = function () {

  return window.innerWidth <= 767

    ? "mobile"

    : window.innerWidth <= 1024

      ? "tablet"

      : "desktop";

};

 

DHCommerce.analytics.getSequence = function () {

  const key = DHCommerce.analytics.sessionKeys.sequence;

 

  const storedValue =

    Number(

      DHCommerce.analytics.getSessionValue(key)

    ) || 0;

 

  const nextValue = storedValue + 1;

 

  DHCommerce.analytics.setSessionValue(key, nextValue);

 

  DHCommerce.sequence = nextValue;

 

  return nextValue;

};

 

DHCommerce.analytics.initializeSession = function () {

  DHCommerce.analytics.getSessionStartedAt();

  DHCommerce.analytics.getLandingPage();

  DHCommerce.analytics.getLandingUrl();

  DHCommerce.analytics.getInitialReferrer();

  DHCommerce.analytics.getAttribution();

 

  const storedSequence =

    Number(

      DHCommerce.analytics.getSessionValue(

        DHCommerce.analytics.sessionKeys.sequence

      )

    ) || 0;

 

  DHCommerce.sequence = storedSequence;

 

  return DHCommerce.analytics.getSessionSnapshot();

};

 

DHCommerce.analytics.getSessionSnapshot = function () {

  const startedAt =

    DHCommerce.analytics.getSessionStartedAt();

 

  return {

    session_id:

      DHCommerce.state.session.id,

 

    visitor_id:

      DHCommerce.state.session.visitorId,

 

    started_at:

      startedAt,

 

    elapsed_ms:

      Math.max(0, Date.now() - startedAt),

 

    landing_page:

      DHCommerce.analytics.getLandingPage(),

 

    landing_url:

      DHCommerce.analytics.getLandingUrl(),

 

    initial_referrer:

      DHCommerce.analytics.getInitialReferrer(),

 

    attribution:

      DHCommerce.analytics.getAttribution(),

 

    internal_traffic:

      DHCommerce.analytics.isInternalTraffic(),

 

    event_count:

      DHCommerce.state.analytics.events.length

  };

};

 

DHCommerce.analytics.buildEvent = function (

  eventName,

  payload

) {

  const now = Date.now();

 

  const startedAt =

    DHCommerce.analytics.getSessionStartedAt();

 

  const attribution =

    DHCommerce.analytics.getAttribution();

 

  const shippingLocation =

    DHCommerce.state.shipping &&

    DHCommerce.state.shipping.location

      ? DHCommerce.state.shipping.location

      : {};

 

  return {

    event_id:

      window.crypto &&

      typeof window.crypto.randomUUID === "function"

        ? window.crypto.randomUUID()

        : DHCommerce.state.session.id +

          "-" +

          now +

          "-" +

          Math.random().toString(36).slice(2),

 

    event_name: eventName,

    session_id: DHCommerce.state.session.id,

    visitor_id: DHCommerce.state.session.visitorId,

    sequence_number: DHCommerce.analytics.getSequence(),

    occurred_at: new Date(now).toISOString(),

    timestamp_ms: now,

    elapsed_ms: Math.max(0, now - startedAt),

    framework_version: DHCommerce.version,

    page_url: window.location.href,

    page_path: window.location.pathname,

    page_query: window.location.search || "",

    page_title: document.title || "",

    landing_page: DHCommerce.analytics.getLandingPage(),

    landing_url: DHCommerce.analytics.getLandingUrl(),

    referrer: document.referrer || null,

    initial_referrer:

      DHCommerce.analytics.getInitialReferrer(),

    traffic_source: attribution.source || "Direct",

    utm_source: attribution.utm_source,

    utm_medium: attribution.utm_medium,

    utm_campaign: attribution.utm_campaign,

    utm_content: attribution.utm_content,

    utm_term: attribution.utm_term,

    click_id: attribution.click_id,

    referrer_host: attribution.referrer_host,

    internal_traffic:

      DHCommerce.analytics.isInternalTraffic(),

 

    shipping_tier:

      DHCommerce.state.shipping &&

      DHCommerce.state.shipping.tier

        ? DHCommerce.state.shipping.tier

        : null,

 

    shipping_effective_tier:

      DHCommerce.state.shipping &&

      DHCommerce.state.shipping.effectiveTier

        ? DHCommerce.state.shipping.effectiveTier

        : null,

 

    shipping_state:

      shippingLocation.state || null,

 

    shipping_city:

      shippingLocation.city || null,

 

    device_type:

      DHCommerce.analytics.getDeviceType(),

 

    viewport_width:

      window.innerWidth || null,

 

    viewport_height:

      window.innerHeight || null,

 

    screen_width:

      window.screen

        ? window.screen.width

        : null,

 

    screen_height:

      window.screen

        ? window.screen.height

        : null,

 

    language:

      window.navigator

        ? window.navigator.language || null

        : null,

 

    payload:

      payload || {}

  };

};

 

DHCommerce.sendAnalyticsEvent = function (event) {

  const remoteEvent =

    event && event.event_name

      ? event

      : DHCommerce.analytics.buildEvent(

          event.name,

          event.payload || {}

        );

 

  return fetch(DHCommerce.analyticsEndpoint, {

    method: "POST",

 

    headers: {

      "Content-Type": "application/json"

    },

 

    body:

      JSON.stringify(remoteEvent),

 

    keepalive: true

  })

    .then(function (response) {

      if (!response.ok) {

        console.warn(

          "DH Commerce analytics server returned",

          response.status

        );

      }

 

      return response;

    })

    .catch(function (error) {

      console.warn(

        "DH Commerce analytics upload failed",

        error

      );

 

      return null;

    });

};

 

/* ======================================================

   EVENT BUS

====================================================== */

 

DHCommerce.emit = function (eventName, payload) {

  payload = payload || {};

 

  const remoteEvent =

    DHCommerce.analytics.buildEvent(

      eventName,

      payload

    );

 

  const event = {

    name: eventName,

    payload: payload,

    sessionId: remoteEvent.session_id,

    visitorId: remoteEvent.visitor_id,

    sequence: remoteEvent.sequence_number,

    frameworkVersion: remoteEvent.framework_version,

    timestamp: remoteEvent.timestamp_ms,

    remoteEvent: remoteEvent

  };

 

  DHCommerce.state.analytics.events.push(event);

 

  DHCommerce.sendAnalyticsEvent(remoteEvent);

 

  document.dispatchEvent(

    new CustomEvent("dhcommerce", {

      detail: event

    })

  );

 

  if (DHCommerce.config.analytics.debug) {

    console.log(

      "%cDH Commerce",

      "color:#c89c3d;font-weight:bold",

      event

    );

  }

 

  return event;

};

 

DHCommerce.on = function (eventName, callback) {

  if (typeof eventName === "function") {

    callback = eventName;

    eventName = null;

  }

 

  if (typeof callback !== "function") {

    return function () {};

  }

 

  const listener = function (event) {

    const commerceEvent = event.detail;

 

    if (

      eventName &&

      commerceEvent.name !== eventName

    ) {

      return;

    }

 

    callback(commerceEvent);

  };

 

  document.addEventListener(

    "dhcommerce",

    listener

  );

 

  return function () {

    document.removeEventListener(

      "dhcommerce",

      listener

    );

  };

};

 

/* ======================================================

   EVENT BUS COMPATIBILITY API

====================================================== */

 

DHCommerce.events = {

  emit: function (eventName, payload) {

    return DHCommerce.emit(

      eventName,

      payload || {}

    );

  },

 

  on: function (eventName, callback) {

    return DHCommerce.on(

      eventName,

      callback

    );

  }

};

 

DHCommerce.analytics.track = function (name, payload) {

  if (!DHCommerce.config.analytics.enabled) {

    return null;

  }

 

  return DHCommerce.emit(

    name,

    payload || {}

  );

};

 

 

  /* ======================================================

     SHIPPING INTELLIGENCE

  ====================================================== */

 

  DHCommerce.shipping = {};

 

  DHCommerce.shipping.validTiers = [

    "near",

    "middle",

    "far",

    "unknown"

  ];

 

/*

  Reads the location and regional-rule data that the

  Shopify section placed on window.DHCommerceBootstrap.

*/

 

DHCommerce.shipping.getBootstrap = function () {

  return (

    window.DHCommerceBootstrap &&

    typeof window.DHCommerceBootstrap === "object"

  )

    ? window.DHCommerceBootstrap

    : {};

};

 

 

/*

  Converts comma-separated state codes such as:

 

  TN, KY, AL

 

  into:

 

  ["TN", "KY", "AL"]

*/

 

DHCommerce.shipping.parseStateList = function (value) {

  if (Array.isArray(value)) {

    return value

      .map(function (state) {

        return String(state || "")

          .trim()

          .toUpperCase();

      })

      .filter(Boolean);

  }

 

  return String(value || "")

    .split(",")

    .map(function (state) {

      return state

        .trim()

        .toUpperCase();

    })

    .filter(Boolean);

};

 

 

/*

  Returns the regional rules configured in the Shopify

  Theme Editor.

*/

 

DHCommerce.shipping.getRegionalRules = function () {

  const bootstrap =

    DHCommerce.shipping.getBootstrap();

 

  const rules =

    bootstrap.regionalRules &&

    typeof bootstrap.regionalRules === "object"

      ? bootstrap.regionalRules

      : {};

 

  return {

    active: rules.active !== false,

 

    key:

      String(rules.key || "us_standard")

        .trim(),

 

    nearStates:

      DHCommerce.shipping.parseStateList(

        rules.nearStates

      ),

 

    middleStates:

      DHCommerce.shipping.parseStateList(

        rules.middleStates

      ),

 

    farStates:

      DHCommerce.shipping.parseStateList(

        rules.farStates

      ),

 

    excludedRegions:

      DHCommerce.shipping.parseStateList(

        rules.excludedRegions

      ),

 

    defaultTier:

      DHCommerce.shipping.normalizeTier

        ? DHCommerce.shipping.normalizeTier(

            rules.defaultTier || "far"

          )

        : String(

            rules.defaultTier || "far"

          ).toLowerCase()

  };

};

 

 

/*

  Resolves a two-letter state code against the Theme

  Editor's Near, Middle, and Far lists.

*/

 

DHCommerce.shipping.resolveTierFromState = function (

  stateCode

) {

  const state =

    String(stateCode || "")

      .trim()

      .toUpperCase();

 

  const rules =

    DHCommerce.shipping.getRegionalRules();

 

  if (!state || rules.active === false) {

    return {

      tier: rules.defaultTier || "far",

      matched: false,

      excluded: false,

      state: state || null

    };

  }

 

  if (rules.excludedRegions.includes(state)) {

    return {

      tier: rules.defaultTier || "far",

      matched: false,

      excluded: true,

      state: state

    };

  }

 

  if (rules.nearStates.includes(state)) {

    return {

      tier: "near",

      matched: true,

      excluded: false,

      state: state

    };

  }

 

  if (rules.middleStates.includes(state)) {

    return {

      tier: "middle",

      matched: true,

      excluded: false,

      state: state

    };

  }

 

  if (rules.farStates.includes(state)) {

    return {

      tier: "far",

      matched: true,

      excluded: false,

      state: state

    };

  }

 

  return {

    tier: rules.defaultTier || "far",

    matched: false,

    excluded: false,

    state: state

  };

};

 

  DHCommerce.shipping.isValidTier = function (tier) {

 

    return (

      DHCommerce.shipping.validTiers.indexOf(tier) !== -1

    );

 

  };

 

  DHCommerce.shipping.normalizeTier = function (tier) {

 

    if (typeof tier !== "string") {

 

      return "unknown";

 

    }

 

    tier = tier

      .trim()

      .toLowerCase();

 

    return DHCommerce.shipping.isValidTier(tier)

      ? tier

      : "unknown";

 

  };

 

  DHCommerce.shipping.getEffectiveTier = function (tier) {

 

    tier = DHCommerce.shipping.normalizeTier(

      tier || DHCommerce.state.shipping.tier

    );

 

    if (tier === "unknown") {

 

      return DHCommerce.config.shipping.unknownBehavior || "far";

 

    }

 

    return tier;

 

  };

 

  DHCommerce.shipping.getRules = function (tier) {

 

    const effectiveTier =

      DHCommerce.shipping.getEffectiveTier(tier);

 

    return (

      DHCommerce.config.shipping[effectiveTier] ||

      DHCommerce.config.shipping.far

    );

 

  };

 

  DHCommerce.shipping.saveSessionTier = function (tier) {

 

    try {

 

      window.sessionStorage.setItem(

        "dhcommerce_shipping_tier",

        tier

      );

 

    } catch (error) {

 

      /*

      Storage may be unavailable in private browsing or

      restricted browser environments. Shipping still works.

      */

 

    }

 

  };

 

  DHCommerce.shipping.getSessionTier = function () {

 

    try {

 

      const tier =

        window.sessionStorage.getItem(

          "dhcommerce_shipping_tier"

        );

 

      return DHCommerce.shipping.isValidTier(tier)

        ? tier

        : null;

 

    } catch (error) {

 

      return null;

 

    }

 

  };

 

/*

  Persistent regional-location cache.

 

  Six hours keeps repeat visits fast while allowing

  travelers to be re-resolved later the same day.

*/

 

DHCommerce.shipping.locationCacheKey =

  "dhcommerce_shipping_location_v1";

 

DHCommerce.shipping.locationCacheLifetime =

  6 * 60 * 60 * 1000;

 

 

DHCommerce.shipping.saveLocationCache = function (

  tier,

  location

) {

  try {

    window.localStorage.setItem(

      DHCommerce.shipping.locationCacheKey,

      JSON.stringify({

        tier:

          DHCommerce.shipping.normalizeTier(tier),

 

        location: {

          country:

            String(

              location && location.country || ""

            )

              .trim()

              .toUpperCase(),

 

          state:

            String(

              location && location.state || ""

            )

              .trim()

              .toUpperCase(),

 

          city:

            String(

              location && location.city || ""

            ).trim(),

 

          zip:

            String(

              location && location.zip || ""

            ).trim()

        },

 

        savedAt: Date.now()

      })

    );

  } catch (error) {

    /*

      The storefront continues normally when local

      storage is unavailable.

    */

  }

};

 

 

DHCommerce.shipping.getLocationCache = function () {

  try {

    const rawValue =

      window.localStorage.getItem(

        DHCommerce.shipping.locationCacheKey

      );

 

    if (!rawValue) {

      return null;

    }

 

    const cached = JSON.parse(rawValue);

 

    if (

      !cached ||

      !cached.savedAt ||

      Date.now() - Number(cached.savedAt) >

        DHCommerce.shipping.locationCacheLifetime

    ) {

      window.localStorage.removeItem(

        DHCommerce.shipping.locationCacheKey

      );

 

      return null;

    }

 

    const tier =

      DHCommerce.shipping.normalizeTier(

        cached.tier

      );

 

    if (

      tier === "unknown" ||

      !cached.location ||

      !cached.location.state

    ) {

      return null;

    }

 

    return {

      tier: tier,

 

      location: {

        country:

          String(

            cached.location.country || ""

          )

            .trim()

            .toUpperCase(),

 

        state:

          String(

            cached.location.state || ""

          )

            .trim()

            .toUpperCase(),

 

        city:

          String(

            cached.location.city || ""

          ).trim(),

 

        zip:

          String(

            cached.location.zip || ""

          ).trim()

      },

 

      savedAt: Number(cached.savedAt)

    };

  } catch (error) {

    return null;

  }

};

 

 

DHCommerce.shipping.setLocation = function (

  location

) {

  location = location || {};

 

  DHCommerce.state.shipping.location = {

    country:

      String(location.country || "")

        .trim()

        .toUpperCase(),

 

    state:

      String(location.state || "")

        .trim()

        .toUpperCase(),

 

    city:

      String(location.city || "")

        .trim(),

 

    zip:

      String(location.zip || "")

        .trim()

  };

 

  return DHCommerce.state.shipping.location;

};

 

  DHCommerce.shipping.getPreviewOverride = function () {

 

    try {

 

      const parameters =

        new URLSearchParams(window.location.search);

 

      const tier =

        parameters.get("dh_shipping");

 

      if (!tier) {

 

        return null;

 

      }

 

      const normalizedTier =

        DHCommerce.shipping.normalizeTier(tier);

 

      return DHCommerce.shipping.isValidTier(

        normalizedTier

      )

        ? normalizedTier

        : null;

 

    } catch (error) {

 

      return null;

 

    }

 

  };

 

  DHCommerce.shipping.setTier = function (

    tier,

    options

  ) {

 

    options = options || {};

 

    const normalizedTier =

      DHCommerce.shipping.normalizeTier(tier);

 

    const effectiveTier =

      DHCommerce.shipping.getEffectiveTier(

        normalizedTier

      );

 

    DHCommerce.state.shipping.tier =

      normalizedTier;

 

    DHCommerce.state.shipping.effectiveTier =

      effectiveTier;

 

    DHCommerce.state.shipping.source =

      options.source || "manual";

 

    DHCommerce.state.shipping.confidence =

      options.confidence || "unknown";

 

    if (options.persist !== false) {

 

      DHCommerce.shipping.saveSessionTier(

        normalizedTier

      );

 

    }

 

    const payload = {

 

      tier: normalizedTier,

 

      effectiveTier: effectiveTier,

 

      source:

        DHCommerce.state.shipping.source,

 

      confidence:

        DHCommerce.state.shipping.confidence,

 

      rules:

        DHCommerce.shipping.getRules(

          normalizedTier

        )

 

    };

 

    DHCommerce.emit(

      "shipping:tier",

      payload

    );

 

    return payload;

 

  };

 

/*

  Reads a logged-in Shopify customer's location from

  the homepage bootstrap data.

*/

 

DHCommerce.shipping.getCustomerLocation = function () {

  const bootstrap =

    DHCommerce.shipping.getBootstrap();

 

  const location =

    bootstrap.customerLocation &&

    typeof bootstrap.customerLocation === "object"

      ? bootstrap.customerLocation

      : {};

 

  return {

    loggedIn: location.loggedIn === true,

 

    country:

      String(location.country || "")

        .trim()

        .toUpperCase(),

 

    state:

      String(location.state || "")

        .trim()

        .toUpperCase(),

 

    city:

      String(location.city || "")

        .trim(),

 

    zip:

      String(location.zip || "")

        .trim()

  };

};

 

/*

  Attempts to determine an anonymous visitor's state

  through an approximate IP-location lookup.

 

  This does not request browser GPS permission and never

  blocks the storefront if the service is unavailable.

*/

 

DHCommerce.shipping.getAnonymousLocation = function () {

  const controller =

    typeof AbortController !== "undefined"

      ? new AbortController()

      : null;

 

  const timeoutId = window.setTimeout(function () {

    if (controller) {

      controller.abort();

    }

  }, 2500);

 

  return fetch("https://ipapi.co/json/", {

    method: "GET",

    headers: {

      Accept: "application/json"

    },

    signal: controller

      ? controller.signal

      : undefined

  })

    .then(function (response) {

      if (!response.ok) {

        throw new Error(

          "Anonymous location lookup failed."

        );

      }

 

      return response.json();

    })

    .then(function (location) {

      window.clearTimeout(timeoutId);

 

      return {

        country:

          String(

            location.country_code || ""

          )

            .trim()

            .toUpperCase(),

 

        state:

          String(

            location.region_code || ""

          )

            .trim()

            .toUpperCase(),

 

        city:

          String(location.city || "")

            .trim(),

 

        zip:

          String(location.postal || "")

            .trim()

      };

    })

    .catch(function (error) {

      window.clearTimeout(timeoutId);

 

      console.warn(

        "[DH Commerce] Anonymous location was not resolved:",

        error

      );

 

      return null;

    });

};

 

 

/*

  Resolves an anonymous visitor against the Near,

  Middle, and Far state lists supplied by Shopify.

*/

 

DHCommerce.shipping.resolveAnonymousVisitor = function () {

  return DHCommerce.shipping

    .getAnonymousLocation()

    .then(function (location) {

      if (

        !location ||

        location.country !== "US" ||

        !location.state

      ) {

        return null;

      }

 

      const resolution =

  DHCommerce.shipping.resolveTierFromState(

    location.state

  );

 

if (!resolution.matched) {

  return null;

}

 

DHCommerce.shipping.setLocation(location);

 

DHCommerce.shipping.saveLocationCache(

  resolution.tier,

  location

);

 

const payload =

  DHCommerce.shipping.setTier(

    resolution.tier,

    {

      source: "ip_state",

      confidence: "estimated",

      persist: true

    }

  );

 

payload.location =

  DHCommerce.state.shipping.location;

 

DHCommerce.emit(

  "shipping:location",

  {

    tier: resolution.tier,

    source: "ip_state",

    confidence: "estimated",

    location: location

  }

);

 

return payload;

});

};

 

DHCommerce.shipping.init = function () {

 

    if (DHCommerce.state.shipping.initialized) {

 

      return DHCommerce.state.shipping;

 

    }

 

    let tier = "unknown";

 

    let source = "default";

 

    let confidence = "unknown";

 

    /*

    Preview testing:

 

    Add one of these to the preview URL:

 

    ?dh_shipping=near

    ?dh_shipping=middle

    ?dh_shipping=far

    ?dh_shipping=unknown

    */

 

    const previewTier =

  DHCommerce.shipping.getPreviewOverride();

 

const sessionTier =

  DHCommerce.shipping.getSessionTier();

 

const locationCache =

  DHCommerce.shipping.getLocationCache();

 

const customerLocation =

  DHCommerce.shipping.getCustomerLocation();

 

const customerResolution =

  customerLocation.loggedIn &&

  customerLocation.state

    ? DHCommerce.shipping.resolveTierFromState(

        customerLocation.state

      )

    : null;

 

    if (previewTier) {

 

  tier = previewTier;

 

  source = "preview_override";

 

  confidence = "testing";

 

} else if (

  customerResolution &&

  customerResolution.matched

) {

 

  tier = customerResolution.tier;

 

  source = "shopify_customer_state";

 

  confidence = "verified_customer_address";

 

} else if (locationCache) {

 

  tier = locationCache.tier;

 

  source = "location_cache";

 

  confidence = "recent_ip_estimate";

 

  DHCommerce.shipping.setLocation(

    locationCache.location

  );

 

} else if (sessionTier) {

 

  tier = sessionTier;

 

  source = "session";

 

  confidence = "previously_assigned";

 

}

 

    DHCommerce.shipping.setTier(

      tier,

      {

        source: source,

        confidence: confidence,

        persist: source !== "preview_override"

      }

    );

 

    DHCommerce.state.shipping.initialized = true;

 

    const readyPayload = {

 

      tier:

        DHCommerce.state.shipping.tier,

 

      effectiveTier:

        DHCommerce.state.shipping.effectiveTier,

 

      source:

        DHCommerce.state.shipping.source,

 

      confidence:

        DHCommerce.state.shipping.confidence,

 

      rules:

        DHCommerce.shipping.getRules()

 

    };

 

    DHCommerce.emit(

      "shipping:ready",

      readyPayload

    );

 

/*

  Anonymous visitors receive the conservative fallback

  immediately, then update asynchronously when their

  state is successfully resolved.

 

  URL overrides and verified customer addresses remain

  higher priority.

*/

 

if (

  !previewTier &&

  !locationCache &&

  !sessionTier &&

  !(

    customerResolution &&

    customerResolution.matched

  )

) {

  DHCommerce.shipping.resolveAnonymousVisitor();

}

 

    return DHCommerce.state.shipping;

 

  };

 

    /* ======================================================

     PROMOTIONS

  ====================================================== */

 

  DHCommerce.promotions = {};

 

  /*

  Returns the complete promotion library.

  */

 

  DHCommerce.promotions.getLibrary = function () {

 

    return (

      DHCommerce.config.promotions &&

      DHCommerce.config.promotions.library

        ? DHCommerce.config.promotions.library

        : {}

    );

 

  };

 

 

  /*

  Returns the configured active promotion ID.

  */

 

  DHCommerce.promotions.getActivePromotionId = function () {

 

    return (

      DHCommerce.config.promotions &&

      DHCommerce.config.promotions.activePromotionId

        ? DHCommerce.config.promotions.activePromotionId

        : null

    );

 

  };

 

 

  /*

  Returns a promotion by ID.

  */

 

  DHCommerce.promotions.getById = function (promotionId) {

 

    if (!promotionId) {

      return null;

    }

 

    const library =

      DHCommerce.promotions.getLibrary();

 

    return library[promotionId] || null;

 

  };

 

 

  /*

  Determines whether a promotion is currently within its

  configured date window.

 

  Null start/end values mean there is no date restriction.

  */

 

  DHCommerce.promotions.isWithinSchedule = function (

    promotion,

    now

  ) {

 

    if (!promotion) {

      return false;

    }

 

    now = now instanceof Date

      ? now

      : new Date();

 

    const nowTime = now.getTime();

 

    if (promotion.startsAt) {

 

      const startTime =

        new Date(promotion.startsAt).getTime();

 

      if (

        !Number.isNaN(startTime) &&

        nowTime < startTime

      ) {

 

        return false;

 

      }

 

    }

 

    if (promotion.endsAt) {

 

      const endTime =

        new Date(promotion.endsAt).getTime();

 

      if (

        !Number.isNaN(endTime) &&

        nowTime > endTime

      ) {

 

        return false;

 

      }

 

    }

 

    return true;

 

  };

 

 

  /*

  Resolves the promotion experience for a shipping tier.

 

  This is the primary function homepage components will use.

  */

 

  DHCommerce.promotions.resolve = function (options) {

 

    options = options || {};

 

    const promotionId =

      options.promotionId ||

      DHCommerce.promotions.getActivePromotionId();

 

    const promotion =

      DHCommerce.promotions.getById(

        promotionId

      );

 

    if (

      !promotion ||

      promotion.active === false ||

      !DHCommerce.promotions.isWithinSchedule(

        promotion,

        options.now

      )

    ) {

 

      return null;

 

    }

 

    const requestedTier =

      DHCommerce.shipping.normalizeTier(

        options.tier ||

        DHCommerce.state.shipping.effectiveTier

      );

 

    const effectiveTier =

      DHCommerce.shipping.getEffectiveTier(

        requestedTier

      );

 

    const tierConfig =

      promotion.tiers &&

      promotion.tiers[effectiveTier]

        ? promotion.tiers[effectiveTier]

        : null;

 

    if (

      !tierConfig ||

      tierConfig.enabled === false

    ) {

 

      return null;

 

    }

 

    return {

 

      id: promotion.id,

 

      name: promotion.name || promotion.id,

 

      type: promotion.type || "general",

 

      priority: promotion.priority || 0,

 

      shippingTier: effectiveTier,

 

      eyebrow: tierConfig.eyebrow || "",

 

      headline: tierConfig.headline || "",

 

      message: tierConfig.message || "",

 

      offerLabel: tierConfig.offerLabel || "",

 

      freeShippingThreshold:

        Number(

          tierConfig.freeShippingThreshold

        ) || 0,

 

      giftThreshold:

        Number(

          tierConfig.giftThreshold

        ) || 0,

 

      giftName:

        tierConfig.giftName || "",

 

      ctaLabel:

        tierConfig.ctaLabel ||

        "Shop Now",

 

      startsAt:

        promotion.startsAt || null,

 

      endsAt:

        promotion.endsAt || null

 

    };

 

  };

 

 

  /*

  Returns the currently resolved promotion.

  */

 

  DHCommerce.promotions.getCurrent = function () {

 

    return DHCommerce.promotions.resolve();

 

  };

 

 

  /*

  Updates promotion unlock states based on a subtotal.

  The subtotal should be passed in dollars, not cents.

  */

 

  DHCommerce.promotions.evaluateCart = function (

    subtotal

  ) {

 

    subtotal = Number(subtotal) || 0;

 

    const promotion =

      DHCommerce.promotions.getCurrent();

 

    if (!promotion) {

 

      DHCommerce.state.promotions.active = [];

 

      DHCommerce.state.promotions.giftUnlocked =

        false;

 

      DHCommerce.state.promotions.freeShippingUnlocked =

        false;

 

      return null;

 

    }

 

    const freeShippingUnlocked =

      promotion.freeShippingThreshold > 0 &&

      subtotal >=

        promotion.freeShippingThreshold;

 

    const giftUnlocked =

      promotion.giftThreshold > 0 &&

      subtotal >=

        promotion.giftThreshold;

 

    DHCommerce.state.promotions.active = [

      promotion.id

    ];

 

    DHCommerce.state.promotions.freeShippingUnlocked =

      freeShippingUnlocked;

 

    DHCommerce.state.promotions.giftUnlocked =

      giftUnlocked;

 

    const payload = {

 

      promotion: promotion,

 

      subtotal: subtotal,

 

      freeShippingUnlocked:

        freeShippingUnlocked,

 

      giftUnlocked:

        giftUnlocked,

 

      amountUntilFreeShipping:

        promotion.freeShippingThreshold > 0

          ? Math.max(

              0,

              promotion.freeShippingThreshold -

              subtotal

            )

          : 0,

 

      amountUntilGift:

        promotion.giftThreshold > 0

          ? Math.max(

              0,

              promotion.giftThreshold -

              subtotal

            )

          : 0

 

    };

 

    DHCommerce.emit(

      "promotion:evaluated",

      payload

    );

 

    return payload;

 

  };

 

 

  /*

  Preserves the original helper for compatibility.

  */

 

  DHCommerce.promotions.unlockGift = function () {

 

    DHCommerce.state.promotions.giftUnlocked = true;

 

    DHCommerce.emit(

      "promotion:gift",

      {

        unlocked: true,

        promotion:

          DHCommerce.promotions.getCurrent()

      }

    );

 

  };

 

 

  /*

  Initializes the active promotion after shipping is ready.

  */

 

  DHCommerce.promotions.init = function () {

 

    const promotion =

      DHCommerce.promotions.getCurrent();

 

    DHCommerce.state.promotions.active =

      promotion

        ? [promotion.id]

        : [];

 

    DHCommerce.emit(

      "promotion:ready",

      {

        promotion: promotion,

        shipping:

          DHCommerce.state.shipping

      }

    );

 

    return promotion;

 

  };

 

  /* ======================================================

     ASSORTMENT

  ====================================================== */

 

  DHCommerce.assortment = {};

 

  DHCommerce.assortment.setSelections = function (items) {

 

    items = Array.isArray(items)

      ? items

      : [];

 

    DHCommerce.state.assortment.selections = items;

 

    DHCommerce.state.assortment.count = items.length;

 

    DHCommerce.emit(

      "assortment:updated",

      {

        count: items.length

      }

    );

 

  };

 

/* ======================================================

   CATALOG

====================================================== */

 

DHCommerce.catalog = {

  products: [],

  assortments: [],

  categories: [],

  registered: false,

  updatedAt: null

};

 

DHCommerce.catalog.storageKey =

  "dhcommerce_catalog_v1";

 

DHCommerce.catalog.persist = function () {

  try {

    window.localStorage.setItem(

      DHCommerce.catalog.storageKey,

      JSON.stringify({

        products: DHCommerce.catalog.products,

        assortments: DHCommerce.catalog.assortments,

        categories: DHCommerce.catalog.categories,

        registered: DHCommerce.catalog.registered,

        updatedAt: DHCommerce.catalog.updatedAt

      })

    );

 

    return true;

  } catch (error) {

    console.warn(

      "[DH Commerce] Catalog could not be saved:",

      error

    );

 

    return false;

  }

};

 

DHCommerce.catalog.hydrate = function () {

  try {

    const storedValue = window.localStorage.getItem(

      DHCommerce.catalog.storageKey

    );

 

    if (!storedValue) {

      return false;

    }

 

    const storedCatalog = JSON.parse(storedValue);

 

    DHCommerce.catalog.products =

      Array.isArray(storedCatalog.products)

        ? storedCatalog.products

        : [];

 

    DHCommerce.catalog.assortments =

      Array.isArray(storedCatalog.assortments)

        ? storedCatalog.assortments

        : [];

 

    DHCommerce.catalog.categories =

      Array.isArray(storedCatalog.categories)

        ? storedCatalog.categories

        : [];

 

    DHCommerce.catalog.registered =

      storedCatalog.registered === true;

 

    DHCommerce.catalog.updatedAt =

      Number(storedCatalog.updatedAt) || null;

 

    DHCommerce.emit(

      "catalog:hydrated",

      {

        productCount:

          DHCommerce.catalog.products.length,

 

        assortmentCount:

          DHCommerce.catalog.assortments.length,

 

        updatedAt:

          DHCommerce.catalog.updatedAt

      }

    );

 

    return true;

  } catch (error) {

    console.warn(

      "[DH Commerce] Stored catalog could not be loaded:",

      error

    );

 

    return false;

  }

};

 

 

/*

  Creates a safe copy so outside components cannot

  accidentally mutate the live catalog.

*/

 

DHCommerce.catalog.clone = function (value) {

  try {

    return JSON.parse(JSON.stringify(value));

  } catch (error) {

    return value;

  }

};

 

 

/*

  Registers the standard product-card catalog supplied

  by the homepage Commerce Engine.

*/

 

DHCommerce.catalog.registerProducts = function (products) {

  products = Array.isArray(products)

    ? products

    : [];

 

  DHCommerce.catalog.products =

    DHCommerce.catalog.clone(products);

 

  DHCommerce.catalog.categories =

    Array.from(

      new Set(

        products

          .map(function (product) {

            return String(

              product && product.category || ""

            )

              .trim()

              .toLowerCase();

          })

          .filter(Boolean)

      )

    );

 

  DHCommerce.catalog.registered = true;

  DHCommerce.catalog.updatedAt = Date.now();

 

  DHCommerce.catalog.persist();

 

  DHCommerce.emit(

    "catalog:products_registered",

    {

      productCount:

        DHCommerce.catalog.products.length,

 

      categoryCount:

        DHCommerce.catalog.categories.length,

 

      categories:

        DHCommerce.catalog.clone(

          DHCommerce.catalog.categories

        )

    }

  );

 

  return DHCommerce.catalog.getProducts();

};

 

 

/*

  Registers the merchant-configured assortment definitions.

*/

 

DHCommerce.catalog.registerAssortments = function (

  assortments

) {

  assortments = Array.isArray(assortments)

    ? assortments

    : [];

 

  DHCommerce.catalog.assortments =

    DHCommerce.catalog.clone(assortments);

 

  DHCommerce.catalog.registered = true;

  DHCommerce.catalog.updatedAt = Date.now();

 

  DHCommerce.catalog.persist();

 

  DHCommerce.emit(

    "catalog:assortments_registered",

    {

      assortmentCount:

        DHCommerce.catalog.assortments.length

    }

  );

 

  return DHCommerce.catalog.getAssortments();

};

 

 

/*

  Returns a safe copy of all standard products.

*/

 

DHCommerce.catalog.getProducts = function () {

  return DHCommerce.catalog.clone(

    DHCommerce.catalog.products

  );

};

 

 

/*

  Returns a safe copy of all assortment definitions.

*/

 

DHCommerce.catalog.getAssortments = function () {

  return DHCommerce.catalog.clone(

    DHCommerce.catalog.assortments

  );

};

 

 

/*

  Returns the currently known product categories.

*/

 

DHCommerce.catalog.getCategories = function () {

  return DHCommerce.catalog.clone(

    DHCommerce.catalog.categories

  );

};

 

 

/*

  Returns the complete merchant catalog snapshot.

*/

 

DHCommerce.catalog.snapshot = function () {

  return {

    registered:

      DHCommerce.catalog.registered,

 

    updatedAt:

      DHCommerce.catalog.updatedAt,

 

    productCount:

      DHCommerce.catalog.products.length,

 

    assortmentCount:

      DHCommerce.catalog.assortments.length,

 

    categories:

      DHCommerce.catalog.getCategories(),

 

    products:

      DHCommerce.catalog.getProducts(),

 

    assortments:

      DHCommerce.catalog.getAssortments()

  };

};

 

/* ======================================================

   SERVER API

====================================================== */

 

DHCommerce.server = {};

 

DHCommerce.server.loadDashboard = function () {

 

  const endpoint =

    DHCommerce.config &&

    DHCommerce.config.analytics

      ? DHCommerce.config.analytics.dashboardEndpoint

      : null;

 

  if (!endpoint) {

    return Promise.reject(

      new Error(

        "DH Commerce dashboard endpoint is not configured."

      )

    );

  }

 

  return fetch(endpoint, {

    method: "GET",

 

    headers: {

      "Accept": "application/json"

    },

 

    cache: "no-store"

  })

    .then(function (response) {

 

      if (!response.ok) {

        throw new Error(

          "Dashboard server returned " +

          response.status

        );

      }

 

      return response.json();

 

    })

    .then(function (dashboardData) {

 

      if (

        !dashboardData ||

        dashboardData.success !== true

      ) {

        throw new Error(

          dashboardData &&

          dashboardData.error

            ? dashboardData.error

            : "Dashboard data was unavailable."

        );

      }

 

      return dashboardData;

 

    })

    .catch(function (error) {

 

      console.error(

        "[DH Commerce] Dashboard request failed:",

        error

      );

 

      throw error;

 

    });

 

};

 

 

  /* ======================================================

     CORE REGISTRY, LIFECYCLE, PLUGINS & DIAGNOSTICS

  ====================================================== */

 

  DHCommerce.utils = DHCommerce.utils || {};

 

  DHCommerce.utils.clone = function (value) {

    if (value === undefined) {

      return undefined;

    }

 

    try {

      return JSON.parse(JSON.stringify(value));

    } catch (error) {

      return value;

    }

  };

 

  DHCommerce.utils.deepMerge = function (target, source) {

    target = target && typeof target === "object" ? target : {};

    source = source && typeof source === "object" ? source : {};

 

    Object.keys(source).forEach(function (key) {

      const sourceValue = source[key];

      const targetValue = target[key];

 

      if (

        sourceValue &&

        typeof sourceValue === "object" &&

        !Array.isArray(sourceValue)

      ) {

        target[key] = DHCommerce.utils.deepMerge(

          targetValue && typeof targetValue === "object"

            ? targetValue

            : {},

          sourceValue

        );

      } else {

        target[key] = DHCommerce.utils.clone(sourceValue);

      }

    });

 

    return target;

  };

 

  DHCommerce.utils.now = function () {

    return Date.now();

  };

 

  DHCommerce.diagnostics = {

    entries: [],

    maxEntries: 250

  };

 

  DHCommerce.addDiagnostic = function (level, code, message, detail) {

    const entry = {

      id: "diagnostic-" + Date.now() + "-" + Math.random().toString(36).slice(2),

      level: String(level || "info").toLowerCase(),

      code: String(code || "general"),

      message: String(message || ""),

      detail: detail === undefined ? null : DHCommerce.utils.clone(detail),

      timestamp: Date.now()

    };

 

    DHCommerce.diagnostics.entries.push(entry);

 

    if (DHCommerce.diagnostics.entries.length > DHCommerce.diagnostics.maxEntries) {

      DHCommerce.diagnostics.entries.splice(

        0,

        DHCommerce.diagnostics.entries.length - DHCommerce.diagnostics.maxEntries

      );

    }

 

    return entry;

  };

 

  DHCommerce.getDiagnostics = function (options) {

    options = options || {};

 

    const level = options.level

      ? String(options.level).toLowerCase()

      : null;

 

    const entries = DHCommerce.diagnostics.entries.filter(function (entry) {

      return !level || entry.level === level;

    });

 

    return DHCommerce.utils.clone(entries);

  };

 

  DHCommerce.clearDiagnostics = function () {

    DHCommerce.diagnostics.entries = [];

    return true;

  };

 

  DHCommerce.hooks = {};

 

  DHCommerce.addHook = function (hookName, callback, priority) {

    if (!hookName || typeof callback !== "function") {

      return function () {};

    }

 

    const name = String(hookName);

    const hook = {

      callback: callback,

      priority: Number(priority) || 0

    };

 

    DHCommerce.hooks[name] = DHCommerce.hooks[name] || [];

    DHCommerce.hooks[name].push(hook);

    DHCommerce.hooks[name].sort(function (a, b) {

      return b.priority - a.priority;

    });

 

    return function () {

      const list = DHCommerce.hooks[name] || [];

      const index = list.indexOf(hook);

 

      if (index !== -1) {

        list.splice(index, 1);

      }

    };

  };

 

  DHCommerce.runHooks = function (hookName, context) {

    const list = (DHCommerce.hooks[String(hookName)] || []).slice();

    let chain = Promise.resolve(context);

 

    list.forEach(function (hook) {

      chain = chain.then(function (currentContext) {

        try {

          const result = hook.callback(currentContext, DHCommerce);

          return result === undefined ? currentContext : result;

        } catch (error) {

          DHCommerce.addDiagnostic(

            "error",

            "hook_failed",

            "Hook failed: " + hookName,

            { error: error && error.message ? error.message : String(error) }

          );

 

          return currentContext;

        }

      });

    });

 

    return chain;

  };

 

  DHCommerce.engines = {};

 

  DHCommerce.registerEngine = function (name, engine, options) {

    options = options || {};

 

    if (!name || !engine || typeof engine !== "object") {

      throw new Error("A valid engine name and engine object are required.");

    }

 

    const engineName = String(name).trim();

 

    if (!engineName) {

      throw new Error("Engine name cannot be empty.");

    }

 

    const existing = DHCommerce.engines[engineName];

 

    if (existing && options.replace !== true) {

      DHCommerce.addDiagnostic(

        "warning",

        "engine_already_registered",

        "Engine is already registered: " + engineName

      );

 

      return existing.instance;

    }

 

    const record = {

      name: engineName,

      version: String(engine.version || options.version || "unknown"),

      instance: engine,

      status: "registered",

      registeredAt: Date.now(),

      initializedAt: null,

      error: null

    };

 

    DHCommerce.engines[engineName] = record;

 

    DHCommerce.emit("engine:registered", {

      name: engineName,

      version: record.version

    });

 

    if (

      DHCommerce.state.initialized &&

      options.initialize !== false &&

      typeof engine.init === "function"

    ) {

      DHCommerce.initializeEngine(engineName);

    }

 

    return engine;

  };

 

  DHCommerce.getEngine = function (name) {

    const record = DHCommerce.engines[String(name || "")];

    return record ? record.instance : null;

  };

 

  DHCommerce.getEngineRecord = function (name) {

    const record = DHCommerce.engines[String(name || "")];

    return record ? DHCommerce.utils.clone({

      name: record.name,

      version: record.version,

      status: record.status,

      registeredAt: record.registeredAt,

      initializedAt: record.initializedAt,

      error: record.error

    }) : null;

  };

 

  DHCommerce.listEngines = function () {

    return Object.keys(DHCommerce.engines).map(function (name) {

      return DHCommerce.getEngineRecord(name);

    });

  };

 

  DHCommerce.initializeEngine = function (name) {

    const record = DHCommerce.engines[String(name || "")];

 

    if (!record) {

      return Promise.resolve(null);

    }

 

    if (record.status === "ready") {

      return Promise.resolve(record.instance);

    }

 

    record.status = "initializing";

    record.error = null;

 

    let result;

 

    try {

      result = typeof record.instance.init === "function"

        ? record.instance.init(DHCommerce)

        : record.instance;

    } catch (error) {

      result = Promise.reject(error);

    }

 

    return Promise.resolve(result)

      .then(function () {

        record.status = "ready";

        record.initializedAt = Date.now();

 

        DHCommerce.emit("engine:ready", {

          name: record.name,

          version: record.version

        });

 

        return record.instance;

      })

      .catch(function (error) {

        record.status = "error";

        record.error = error && error.message

          ? error.message

          : String(error);

 

        DHCommerce.addDiagnostic(

          "error",

          "engine_initialization_failed",

          "Engine failed to initialize: " + record.name,

          { error: record.error }

        );

 

        DHCommerce.emit("engine:error", {

          name: record.name,

          error: record.error

        });

 

        return null;

      });

  };

 

  DHCommerce.initializeEngines = function () {

    return Promise.all(

      Object.keys(DHCommerce.engines).map(function (name) {

        return DHCommerce.initializeEngine(name);

      })

    );

  };

 

  DHCommerce.discoverEngines = function () {

    const candidates = {

      rules: window.DHCommerceRules,

      offers: window.DHCommerceOffers,

      personalization: window.DHCommercePersonalization,

      recommendations: window.DHCommerceRecommendations,

      experiments: window.DHCommerceExperiments,

      ui: window.DHCommerceUI,

      config: window.DHCommerceConfig,

      bootstrap: window.DHCommerceBootstrapModule

    };

 

    Object.keys(candidates).forEach(function (name) {

      const engine = candidates[name];

 

      if (engine && typeof engine === "object" && !DHCommerce.engines[name]) {

        DHCommerce.registerEngine(name, engine, { initialize: false });

      }

    });

 

    return DHCommerce.listEngines();

  };

 

  DHCommerce.plugins = {};

 

  DHCommerce.registerPlugin = function (name, plugin, options) {

    options = options || {};

 

    if (!name || !plugin) {

      throw new Error("A valid plugin name and plugin are required.");

    }

 

    const pluginName = String(name).trim();

 

    if (DHCommerce.plugins[pluginName] && options.replace !== true) {

      return DHCommerce.plugins[pluginName].instance;

    }

 

    const record = {

      name: pluginName,

      version: String(plugin.version || options.version || "unknown"),

      instance: plugin,

      status: "registered",

      registeredAt: Date.now(),

      initializedAt: null,

      error: null

    };

 

    DHCommerce.plugins[pluginName] = record;

 

    try {

      if (typeof plugin.install === "function") {

        plugin.install(DHCommerce, options);

      } else if (typeof plugin === "function") {

        plugin(DHCommerce, options);

      }

 

      record.status = "ready";

      record.initializedAt = Date.now();

    } catch (error) {

      record.status = "error";

      record.error = error && error.message ? error.message : String(error);

 

      DHCommerce.addDiagnostic(

        "error",

        "plugin_installation_failed",

        "Plugin failed to install: " + pluginName,

        { error: record.error }

      );

    }

 

    DHCommerce.emit("plugin:registered", {

      name: pluginName,

      version: record.version,

      status: record.status

    });

 

    return plugin;

  };

 

  DHCommerce.listPlugins = function () {

    return Object.keys(DHCommerce.plugins).map(function (name) {

      const record = DHCommerce.plugins[name];

 

      return {

        name: record.name,

        version: record.version,

        status: record.status,

        registeredAt: record.registeredAt,

        initializedAt: record.initializedAt,

        error: record.error

      };

    });

  };

 

  DHCommerce.applyConfig = function (config) {

    if (!config || typeof config !== "object") {

      return DHCommerce.config;

    }

 

    DHCommerce.config = DHCommerce.utils.deepMerge(

      DHCommerce.config,

      config

    );

 

    DHCommerce.emit("config:applied", {

      keys: Object.keys(config)

    });

 

    return DHCommerce.config;

  };

 

  DHCommerce.getBootstrapData = function () {

    return window.DHCommerceBootstrap &&

      typeof window.DHCommerceBootstrap === "object"

      ? window.DHCommerceBootstrap

      : {};

  };

 

  DHCommerce.applyBootstrap = function () {

    const bootstrap = DHCommerce.getBootstrapData();

 

    if (bootstrap.config && typeof bootstrap.config === "object") {

      DHCommerce.applyConfig(bootstrap.config);

    }

 

    if (bootstrap.customer && typeof bootstrap.customer === "object") {

      DHCommerce.state.customer = DHCommerce.utils.deepMerge(

        DHCommerce.state.customer,

        bootstrap.customer

      );

    }

 

    DHCommerce.emit("bootstrap:applied", {

      keys: Object.keys(bootstrap)

    });

 

    return bootstrap;

  };

 

  DHCommerce.getHealth = function () {

    const engines = DHCommerce.listEngines();

    const plugins = DHCommerce.listPlugins();

    const engineErrors = engines.filter(function (engine) {

      return engine.status === "error";

    });

    const pluginErrors = plugins.filter(function (plugin) {

      return plugin.status === "error";

    });

 

    const health = {

      status:

        engineErrors.length || pluginErrors.length

          ? "degraded"

          : DHCommerce.state.initialized

            ? "healthy"

            : "initializing",

      name: DHCommerce.name,

      version: DHCommerce.version,

      build: DHCommerce.build,

      initialized: DHCommerce.state.initialized,

      engines: engines,

      plugins: plugins,

      diagnostics: {

        total: DHCommerce.diagnostics.entries.length,

        errors: DHCommerce.diagnostics.entries.filter(function (entry) {

          return entry.level === "error";

        }).length,

        warnings: DHCommerce.diagnostics.entries.filter(function (entry) {

          return entry.level === "warning";

        }).length

      },

      shipping: {

        initialized: DHCommerce.state.shipping.initialized,

        tier: DHCommerce.state.shipping.tier,

        effectiveTier: DHCommerce.state.shipping.effectiveTier,

        source: DHCommerce.state.shipping.source,

        confidence: DHCommerce.state.shipping.confidence

      },

      catalog: DHCommerce.catalog && typeof DHCommerce.catalog.snapshot === "function"

        ? DHCommerce.catalog.snapshot()

        : null,

      generatedAt: Date.now()

    };

 

    return DHCommerce.utils.clone(health);

  };

 

  /* ======================================================

     DASHBOARD

  ====================================================== */

 

  DHCommerce.dashboard = {};

 

  DHCommerce.dashboard.snapshot = function () {

    return {

      name: DHCommerce.name,

      version: DHCommerce.version,

      build: DHCommerce.build,

      health: DHCommerce.getHealth(),

      diagnostics: DHCommerce.getDiagnostics(),

      engines: DHCommerce.listEngines(),

      plugins: DHCommerce.listPlugins(),

      state: DHCommerce.utils.clone(DHCommerce.state),

      catalog:

        DHCommerce.catalog &&

        typeof DHCommerce.catalog.snapshot === "function"

          ? DHCommerce.catalog.snapshot()

          : null,

      promotion:

        DHCommerce.promotions &&

        typeof DHCommerce.promotions.getCurrent === "function"

          ? DHCommerce.promotions.getCurrent()

          : null,

      generatedAt: Date.now()

    };

  };

 

  /* ======================================================

     INIT

  ====================================================== */

 

  DHCommerce.init = function () {

 

  if (DHCommerce.state.initialized) {

    return Promise.resolve(DHCommerce);

  }

 

  DHCommerce.addDiagnostic(

    "info",

    "framework_initializing",

    "DH Commerce Framework initialization started.",

    { version: DHCommerce.version, build: DHCommerce.build }

  );

 

  DHCommerce.applyBootstrap();

  DHCommerce.discoverEngines();

 

  /*

    Restore persisted catalog data before announcing that

    the framework is ready.

 

    Homepage modules may respond to framework:initialized

    by registering fresh products and assortments. Hydration

    must happen first so stored data cannot overwrite the

    freshly registered merchant configuration.

  */

 

  if (

    DHCommerce.catalog &&

    typeof DHCommerce.catalog.hydrate === "function"

  ) {

    DHCommerce.catalog.hydrate();

  }

 

  if (

    DHCommerce.analytics &&

    typeof DHCommerce.analytics.initializeSession === "function"

  ) {

    DHCommerce.analytics.initializeSession();

  }

 

  DHCommerce.state.initialized = true;

 

  DHCommerce.emit(

    "framework:initialized",

    {

      version: DHCommerce.version

    }

  );

 

  DHCommerce.shipping.init();

 

  DHCommerce.promotions.init();

 

  return DHCommerce.runHooks("framework:afterInit", {

    framework: DHCommerce

  })

    .then(function () {

      return DHCommerce.initializeEngines();

    })

    .then(function () {

      DHCommerce.addDiagnostic(

        "info",

        "framework_ready",

        "DH Commerce Framework initialization completed.",

        { version: DHCommerce.version }

      );

 

      DHCommerce.emit("framework:ready", {

        version: DHCommerce.version,

        build: DHCommerce.build,

        health: DHCommerce.getHealth()

      });

 

      return DHCommerce;

    });

 

};

 

  window.DHCommerce = DHCommerce;

 

  DHCommerce.init();

 

})(window, document);